import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import theme from 'src/styles/components/OrderAddon.module.scss';

// eslint-disable-next-line import/no-cycle
import OrderAddon from './OrderAddon';

const OrderAddons = React.memo(({
    addons,
    className
}) => (
    <div className={classnames(className, theme.container)}>
        {addons.map((addon) => <OrderAddon key={addon.productId} {...addon} />)}
    </div>
));

OrderAddons.propTypes = {
    addons: PropTypes.arrayOf(PropTypes.object),
    className: PropTypes.string
};

export default OrderAddons;
